export default "__VITE_ASSET__B900nvSh__"